/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialDetailsDto } from '../../models/material-details-dto';

export interface GetMaterials$Params {
  'X-API-Version'?: string;
}

export function getMaterials(http: HttpClient, rootUrl: string, params?: GetMaterials$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaterialDetailsDto>>> {
  const rb = new RequestBuilder(rootUrl, getMaterials.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MaterialDetailsDto>>;
    })
  );
}

getMaterials.PATH = '/api/materials';
